// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__2dX4D","alert":"SettungsInbox_alert__2uPIq"};